export enum FeedbackReportTiming {
    Immediately = 'immediately',
    OneHour = '1-hour',
    TwoHours = '2-hours',
    ThreeHours = '3-hours',
    FourHours = '4-hours',
    FiveHours = '5-hours',
    Once = 'once',
    Twice = 'twice',
    Thrice = 'thrice'
}